 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"6066d991c0666c1adc614307808f398bf3aaeb3b","1":"811127ee18618a1324807e094eb5836b370a7b70","2":"cf7c3716340258ded661fbfb97a657ff6bbae9d2","3":"3f8ad9c0ed29ef62c00d7c3e15c7c39a8fdde7a9","4":"4f4d679a8932a966d1c39581c6d28c97fd9e27eb","5":"5b08e1b33e7ed1f2cd84ec6c1c54500cac0992ac","6":"821c7519e46a913c6bf1694bfb4eacfe96ee470d","7":"f8f78ec9345a4c520c7b7c9201a6604319c79205","8":"1f5f20e4a04417f6de56067ad393b1ac543ee606","9":"7709c0aa9c2b0a72f665b31530cac433e88f7c9f","10":"d6fb72447eac8cd180a7f0a4c934f0c7fea9978b","11":"df489087748e49f1205276c4f94fc45b5f174da7","12":"e98749e07d83c43b0c6ce3dcf385ecf4fa835194","14":"8a3ad8a8","16":"component---src-pages-404-js","17":"component---src-pages-about-index-js","18":"component---src-pages-brand-assets-index-js","19":"component---src-pages-brand-guides-index-js","20":"component---src-pages-brand-story-index-js","21":"component---src-pages-community-index-js","22":"component---src-pages-dashboard-index-js","23":"component---src-pages-get-started-index-js","24":"component---src-pages-glossary-index-js","25":"component---src-pages-index-js","26":"component---src-pages-manifesto-index-js","27":"component---src-pages-privacy-policy-index-js","28":"component---src-pages-roadmap-index-js","29":"component---src-pages-token-index-js","30":"component---src-templates-verification-js"}[chunkId]||chunkId) + "-" + {"0":"3a575fb5c15f7d0067b5","1":"ff8a06c4543c01c1487a","2":"a0a3194cd5db6812bcaf","3":"a2b310cbf5a3cea18a45","4":"040b7d5776cd94a6884a","5":"9b9936a184a1f0022b37","6":"73ff4795c9d1725822b7","7":"27fc01dedf97fe8fc94f","8":"07ab29e6803f2623b013","9":"1036a8712f1a19f8cb8d","10":"5709d26f95c36dd14578","11":"c3284801c664dd910635","12":"1384c4b40ed79564e8b9","14":"8b38cf18435a724836a3","16":"bfd06c619fdb7ca775be","17":"33e6734503892a2c52a5","18":"27e31aed325f897de21a","19":"0a99963882dafad6919d","20":"819243df95ffc79d9552","21":"d306acdb2a10a7ff297f","22":"8db67c5187b7b8ad64da","23":"a6ed3b26854512b106a4","24":"c1fd2f85813dfedeea70","25":"565ef83ccd52b8501c50","26":"fbc488f34c34195afa92","27":"85d05e1dabc9ed5b8001","28":"c3ea9af6c1b9159b5752","29":"d0c5cff3d634b619fee2","30":"86781a7aeb603c07432a","34":"3377f7f2162c7c146d7b","35":"4ce5b70f04681490a711"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"6066d991c0666c1adc614307808f398bf3aaeb3b","1":"811127ee18618a1324807e094eb5836b370a7b70","2":"cf7c3716340258ded661fbfb97a657ff6bbae9d2","3":"3f8ad9c0ed29ef62c00d7c3e15c7c39a8fdde7a9","4":"4f4d679a8932a966d1c39581c6d28c97fd9e27eb","5":"5b08e1b33e7ed1f2cd84ec6c1c54500cac0992ac","6":"821c7519e46a913c6bf1694bfb4eacfe96ee470d","7":"f8f78ec9345a4c520c7b7c9201a6604319c79205","8":"1f5f20e4a04417f6de56067ad393b1ac543ee606","9":"7709c0aa9c2b0a72f665b31530cac433e88f7c9f","10":"d6fb72447eac8cd180a7f0a4c934f0c7fea9978b","11":"df489087748e49f1205276c4f94fc45b5f174da7","12":"e98749e07d83c43b0c6ce3dcf385ecf4fa835194","14":"8a3ad8a8","16":"component---src-pages-404-js","17":"component---src-pages-about-index-js","18":"component---src-pages-brand-assets-index-js","19":"component---src-pages-brand-guides-index-js","20":"component---src-pages-brand-story-index-js","21":"component---src-pages-community-index-js","22":"component---src-pages-dashboard-index-js","23":"component---src-pages-get-started-index-js","24":"component---src-pages-glossary-index-js","25":"component---src-pages-index-js","26":"component---src-pages-manifesto-index-js","27":"component---src-pages-privacy-policy-index-js","28":"component---src-pages-roadmap-index-js","29":"component---src-pages-token-index-js","30":"component---src-templates-verification-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"b706ce99cdc419238d78","18":"151dbe000ebd371138c0","19":"5aa68eec338a2efafaec","20":"f15c22595a13ba72c033","21":"c9358063ebe9a4cd7fb7","22":"ac1725f7c7360fd89407","23":"523f6157f4d8dffd18e2","24":"0ec50cc4d62fce57097f","25":"38bbe4ca2a2611f7ab97","26":"60852e66530eff9d2d3c","27":"22eb8cf696cdef250113","28":"cf1a94a46619ea5a68b9","29":"02542e3f40777a4bbab0","30":"21e6c7698bcdf28947c1","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
